import { c as _c } from "react/compiler-runtime";
import { Trash02Icon } from '@systemeio/icons';
import { CurrencyEnum } from '@systemeio/types';
import { DigitalProductDeleteModal, useDigitalProductDeleteModal } from 'modules/digital-product/components/digital-product-delete';
import { DigitalProductSourceEnum } from 'modules/digital-product/enums/digital-product-source-enum';
import { useDigitalProductsList } from 'modules/digital-product/hooks/use-digital-product-list';
import { DigitalProductId, DigitalProductInterface } from 'modules/digital-product/types/digital-product-interface';
import { getDigitalProductsData } from 'modules/digital-product/utils/get-digital-products-data';
import React, { ReactNode } from 'react';
import { Button, FormSelect } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface DigitalProductSelectFieldProps {
  'aria-label'?: string;
  currency: CurrencyEnum;
  isBump?: boolean;
  label?: ReactNode;
  /** Called when the currently picked product is removed from the account. */
  onDeleted?: (id: DigitalProductId) => void;
  onChange: (product: DigitalProductInterface) => void;
  /** Keeps the field in its loading state while the owner is busy, e.g. loading the picked product. */
  isPreFetching?: boolean;
  required?: boolean;
  source: DigitalProductSourceEnum;
  value?: DigitalProductId;
  disabled?: boolean;
}

/**
 * Digital product picker with per-option removal from the account.
 */
export function DigitalProductSelectField(t0) {
  const $ = _c(42);
  const {
    "aria-label": ariaLabel,
    currency,
    isBump,
    isPreFetching,
    label,
    onChange,
    onDeleted,
    required,
    source,
    value,
    disabled
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    digitalProductList,
    mutate
  } = useDigitalProductsList(currency, source);
  const deleteModal = useDigitalProductDeleteModal();
  let t1;
  if ($[0] !== deleteModal || $[1] !== mutate || $[2] !== onDeleted || $[3] !== value) {
    t1 = async () => {
      const {
        digitalProductId
      } = deleteModal;
      if (!digitalProductId) {
        return;
      }
      await deleteModal.deleteDigitalProduct();
      await mutate(data => data?.filter(el => el.id !== digitalProductId), false);
      if (digitalProductId === value) {
        onDeleted?.(digitalProductId);
      }
    };
    $[0] = deleteModal;
    $[1] = mutate;
    $[2] = onDeleted;
    $[3] = value;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleDelete = t1;
  let t2;
  if ($[5] !== t) {
    t2 = t("dashboard.digital_product.select_name");
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = !digitalProductList || isPreFetching;
  let t4;
  if ($[7] !== digitalProductList) {
    t4 = digitalProductList ?? [];
    $[7] = digitalProductList;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== deleteModal || $[10] !== t) {
    t5 = id => <Button aria-label={t("global.delete")} size="icon-sm" variant="destructive-ghost" onMouseDown={_temp} onClick={e_0 => {
      e_0.stopPropagation();
      deleteModal.open(id);
    }}><Trash02Icon /></Button>;
    $[9] = deleteModal;
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== isBump || $[13] !== t4 || $[14] !== t5) {
    t6 = getDigitalProductsData(t4, isBump, t5);
    $[12] = isBump;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== digitalProductList || $[17] !== onChange) {
    t7 = id_0 => {
      const selected = digitalProductList?.find(el_0 => el_0.id === id_0);
      if (selected) {
        onChange(selected);
      }
    };
    $[16] = digitalProductList;
    $[17] = onChange;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== ariaLabel || $[20] !== disabled || $[21] !== label || $[22] !== required || $[23] !== t2 || $[24] !== t3 || $[25] !== t6 || $[26] !== t7 || $[27] !== value) {
    t8 = <FormSelect disabled={disabled} aria-label={ariaLabel} label={label} required={required} placeholder={t2} isPreFetching={t3} withoutCloseIcon={true} data={t6} value={value} onChange={t7} />;
    $[19] = ariaLabel;
    $[20] = disabled;
    $[21] = label;
    $[22] = required;
    $[23] = t2;
    $[24] = t3;
    $[25] = t6;
    $[26] = t7;
    $[27] = value;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== deleteModal.digitalProductId || $[30] !== digitalProductList) {
    t9 = digitalProductList?.find(el_1 => el_1.id === deleteModal.digitalProductId)?.name;
    $[29] = deleteModal.digitalProductId;
    $[30] = digitalProductList;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] !== deleteModal.afterLeave || $[33] !== deleteModal.close || $[34] !== deleteModal.digitalProductLinkedOffersCount || $[35] !== deleteModal.opened || $[36] !== handleDelete || $[37] !== t9) {
    t10 = <DigitalProductDeleteModal opened={deleteModal.opened} digitalProductName={t9} digitalProductLinkedOffersCount={deleteModal.digitalProductLinkedOffersCount} onClose={deleteModal.close} afterLeave={deleteModal.afterLeave} onConfirm={handleDelete} />;
    $[32] = deleteModal.afterLeave;
    $[33] = deleteModal.close;
    $[34] = deleteModal.digitalProductLinkedOffersCount;
    $[35] = deleteModal.opened;
    $[36] = handleDelete;
    $[37] = t9;
    $[38] = t10;
  } else {
    t10 = $[38];
  }
  let t11;
  if ($[39] !== t10 || $[40] !== t8) {
    t11 = <>{t8}{t10}</>;
    $[39] = t10;
    $[40] = t8;
    $[41] = t11;
  } else {
    t11 = $[41];
  }
  return t11;
}
function _temp(e) {
  return e.stopPropagation();
}